import SingleToilet from './SingleToiletContainer';

export default SingleToilet;
